<template>
    <b-card no-body class="mb-0">
      <b-row class="p-2 pt-3 pb-3">
        <b-col cols :md=12>
          <h5> Select Date Range</h5>
            <vue-ctk-date-time-picker
              id="RangeDatePicker"  label="Select a date range" v-model="range_value"
              format="YYYY-MM-DD" :range="true" formatted="ll">
                <b-button variant="primary"
                  class="m-2" size="md">Current Month</b-button>
              </vue-ctk-date-time-picker>
        </b-col>
        <!-- <b-col v-if="dashboardId != null" cols :md=6>
          <h5>Step 2: Select report from dashboard to view</h5>
          <b-form-select
            v-model="report_"
            :options="reportOptions"
            disabled-field="notEnabled"
            style="max-width: 300px;"
            size="lg"
            @change="selectReport()"
            >
          </b-form-select>
        </b-col> -->
      </b-row>
      <!-- <b-row class="p-2 pt-3 pb-3">
        <b-col cols :md=6>
          <h5>Step 1: Select dashboard</h5>
          <b-form-select
            v-model="dashboardId"
            :options="dashboards"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            style="max-width: 300px;"
            size="lg"
            @change="getDashboard()"
            >
          </b-form-select>
        </b-col>
        <b-col v-if="dashboardId != null" cols :md=6>
          <h5>Step 2: Select report from dashboard to view</h5>
          <b-form-select
            v-model="report_"
            :options="reportOptions"
            disabled-field="notEnabled"
            style="max-width: 300px;"
            size="lg"
            @change="selectReport()"
            >
          </b-form-select>
        </b-col>
      </b-row> -->

      <b-tabs v-if="insight != null" card nav-class="pt-3 pl-2" class="tabs" v-model="tab" :key="insight.id">
        <b-row>
          <b-col :cols="12">
            <!-- {{ insight }} -->
            <!-- <date-insight
              v-for="dateInsight in dateInsights"
              :key="dateInsight['slug']"
              v-bind="dateInsight"
              :data-file-type="dataFileType"/> -->


            

            <!-- <categorical-insight 
              v-if="insight && insight.report_type === 'chart'"
              :report-id="reportId"
              :dashboard-id="dashboardId"
              :name="insight.title"
              :subtitle="insight.config.subtitle"
              :values="insight.value"
              :xlabel="insight.config.xlabel"
              :xlabeltype="insight.config.xlabeltype"
              :ylabel="insight.config.ylabel"
              :default-chart="insight.config.default_chart_type"
              :drilldown="insight.config.drill_down"
              :grouped="insight.config.grouped"
              :width="4"
              :isString="true">

            </categorical-insight> -->

            <b-card
              header-tag="header"
              header-class="card-header-padding"
              class="card-style">
              <template v-slot:header style="padding: 0 !important">
                <b-dropdown class="pull-right" size="sm" v-model="chartType" @change="switchChart()" variant="default" no-caret="">
                  <template v-slot:button-content>
                    <b-icon icon="bar-chart-fill"></b-icon>
                  </template>
                  <b-dropdown-item v-for="item in supportedCharts" :key="item.label" @click="switchChart()" v-bind:value="item.value">{{ item.label }}</b-dropdown-item>
                </b-dropdown>
              </template>
              <chart :options="chartOptions" style="height: 100%; position: relative;" />
            </b-card>

            <!-- <single-value-insights
              :values="categoricalSingleValuedData"/> -->
          </b-col>
        </b-row>

      </b-tabs>
    </b-card>
</template>

<script>
  import axios from 'axios';
  import DynamicRules from '../Insights/DynamicRules';
  import ConditionalTab from '../Insights/ConditionalTab';
  import ConditionalSection from '../Insights/ConditionalSection';
  import FilterInput from '../Insights/FilterInput';
  import Insights from "../Insights";
  import CategoricalInsight from '../Insights/CategoricalInsight';
  import { fetchInsight, maybeMissingValueLabel, titleCase, CATEGORICAL_INSIGHT_HEIGHT } from '../Insights/utils';
  import CategoricalInsightMixin from '../Insights/CategoricalInsightsMixin';
  import InsightsComputationMixin from '../Insights/InsightsComputationMixin';
  import ObjectHash from "object-hash";
  import { fullURL } from '../../utils';
  // import CategoricalInsightContainer from './CategoricalInsightContainer';
  import {Chart} from 'highcharts-vue';
  import HighChartsDrillDown from 'highcharts/modules/drilldown'
  import Highcharts from 'highcharts'
  import loadDrillDown from 'highcharts/modules/drilldown'
  import {round} from "lodash/math";
  import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
  import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
  import moment from "moment";
  loadDrillDown(Highcharts);
  const parseCategory = (value, type) => {
    if (type === "date") {
      return moment(value).format("MMM DD, YYYY");
    }
    return value;
  };

  export default {
    name: 'ExploreReport',

    components: {
      CategoricalInsight,
      DynamicRules,
      ConditionalTab,
      Insights,

      ConditionalSection,
      FilterInput,
      Chart,
      VueCtkDateTimePicker
    },

    props: {
      dashboardId: String,
      reportId: String,
      segmentID: String
    },


    data() {
      return {
        tab: 0,
        loading: false,
        dashboard_: null,
        range_value: null,
        report_: null,
        reportData: {},
        reports: [],
        insight: this.getReport(),
        idList: [],
        selectedItem: "",
        chartType: "",
        chartTitle: "",
        chartData: [],
        start_date: null,
        end_date: null,
        groups: [],
        groupNames: [],
        groupView: null,
        filter: {
          method: "dynamic",
          values: {
            filters: [],
            logic: "and"
          }
        }
      };

    },

    computed: {
      reportOptions() {
        var reports = [];
        const request_data = "?dashboard_id=" + this.dashboardId;
        
        var dashboard = this.getDashboard();
        console.log("Request Dashboard: ", this.dashboardId, this.dashboard_);
        if (!!this.dashboard_ && !!this.dashboard_.report_ids) {
          this.dashboard_.report_ids.forEach(id => {
            // this.loading = true;
            axios.get(
              fullURL(`/dashboards/report/${id.report_id}` + request_data)
              ).then(({data}) =>{
                console.log("Response Data: ", {'text': data.title, 'value': data.id});
                this.reportData[id.report_id] = data;
                reports.push({'text': data.title, 'value': data.id});
              })
            });
        }

        console.log("Reports: ", this.reportData);
        // if (!!this.reportId) {
        //   this.selectReport();
        // }
        return reports;
      },

      dashboards() {
        var dashboards = [];
        this.$store.state.files.dashboards.forEach(dashboard => {
          dashboards.push({'name': dashboard.title, 'item': dashboard.id});
        });
        return dashboards;
      },
    
      hash() {
        ObjectHash(this.filter);
      },

      hasData() {
				return this.insight.value; // && this.values.length > 1;
      },

      modalID() {
        return "modal-" + this.name;
      },

      innerStyle() {
        const spacing = "20px 4px";
        return {
          height: `${CATEGORICAL_INSIGHT_HEIGHT}px`,
          width: `calc(100% - ${spacing} * 2)`,
          margin: spacing,
          position: "relative"
        };
      },

      selectOptions() {
        return Object.keys(this.values);
      },

      supportedCharts() {
        return [
          {label: 'bar', value: 'bar'},
          {label: 'column', value: 'column'},
          {label: 'line', value: 'spline'},
          {label: 'area', value: 'areaspline'},
          {label: 'pie', value: 'pie'}
          ];
      },

      widthColumns() {
			  return (!!this.width) ? this.width : (this.values.length >= 2 && this.isString) || this.isObject || this.isArray ? 2 : 1;
      },

			chartOptions() {
        this.chartType = this.insight.config.default_chart_type;
        this.chartTitle = this.insight.title;
        this.chartData = this.insight.value;
				console.log("chart options", this.insight.config.xlabel, this.insight.title, this.chartData);
        console.log("Checker: ", this.insight.value);
				if (!this.hasData) return {};
				// if (this.isObject && !this.isArray) return this.stackedBarChartOptions;
				// if (this.isArray && typeof this.chartData[0][0] === 'string') isString = true;
        // else if(this.chartType === "map") {
        //   return this.mapChartOptions;
        // }
        if (this.insight.config.drilldown && this.insight.config.subtitle) {
				  console.log("drilldown", this.chartData)
				  return this.drillDownChartOptions;
				  // return this.barChartOptions
        }
        if (this.insight.config.grouped) {
          return this.groupedBarChartOptions;
        }
				// else if (this.isObject) {
        //   this.chartTitle = (!!this.chartTitle) ? this.chartTitle : this.name + " - " + Object.keys(this.values)[0];
        //   this.chartData = (!!this.chartData && this.chartData.length > 0) ? this.chartData : this.insight.chart_data.data[Object.keys(this.insight.chart_data.data)[0]];
        //   return this.nestedBarChartOptions;
        // }
				else if (!!this.insight.config.xlabeltype && this.insight.config.xlabeltype === "date") return this.barChartOptions;
        else if (this.insight.value.length > 2) return this.barChartOptions;
        // else if (this.values.length >= 2) return this.groupedBarChartOptions;
        else if (this.insight.value.length == 1) return this.barChartOptions;
        console.log("Checker: ", this.insight.value);
				return this.pieChartOptions;
      },

      nestedBarChartOptions() {
        let categories = this.chartData.map(bin => bin[0]);
        let chart = this.isString || this.isObject ? 'bar' : 'column';
        this.chartType = (!!this.chartType) ? this.chartType : chart;
				return {
					chart: {
						type: this.chartType
					},
					title: {
						text: titleCase(this.chartTitle)
					},
					xAxis: {
						categories: categories,
						crosshair: true
					},
					yAxis: {
						min: 0,
						title: {
							text: this.title
						}
					},
					tooltip: {
						headerFormat: '',
						pointFormat: '<b>{point.y}</b>',
						footerFormat: '',
						shared: true,
						useHTML: true
					},
					plotOptions: {
						column: {
							pointPadding: 0.2,
							borderWidth: 0,
              dataLabels: {
								enabled: true,
                format: '<b>{point.y}</b>'
							}
						}
					},
					series: [{
						showInLegend: false,
						name: titleCase(this.name),
						data: this.chartData.map(point => point[1])
					}]
				};
      },

			stackedBarChartOptions() {
        let series = [];
        let xKeys = [];
        let xLabels = [];
        let xValues = {};
        let notSet = 0;
        // this.values.map(bin => bin[0]).forEach(element => {console.log(Object.keys(element));})
        this.values.forEach(element => {
          let count = element[1];
          if (this.checkIfObject(element[0]) && element[0] != {}) {
            Object.keys(element[0]).forEach(e => {
              if (xKeys.indexOf(e) < 0) {
                xKeys.push(e);
              }
              // console.log(e, xValues, xValues[e]);
              if (!!xValues[e]) {
                console.log(element[0][e], xValues[e]);
                if (xLabels.indexOf(element[0][e]) < 0) xLabels.push(element[0][e]);
                if (element[0][e] in xValues[e]) {
                  xValues[e][element[0][e]] += count;
                } else {
                  xValues[e][element[0][e]] = count;
                }
              } else {
                xValues[e] = {};
                xValues[e][element[0][e]] = count;
              }
            });
          }
          // console.log(element[0]);
          count = 0;
        });

        // xLabels.push("not set");
        xLabels.forEach(x => {
          let data = [];
          if (x !== 'not set') {
            data = Object.values(xValues).map(a => a[x]);
          } else {
            for (let i=0; i<Object.values(xValues).length; i++) {
              data.push(notSet);
            }
          }
          var newData = [];
          data.forEach(x => {
            newData.push((!!x) ? x : null);
          });
          series.push({"name": x, "data": newData});
        });
        console.log("Labels: ", xLabels, series);
        this.chartType = (!!this.chartType) ? this.chartType : 'bar';
				return {
					chart: {
						type: this.chartType
					},
					title: {
						text: titleCase(this.name)
					},
					xAxis: {
						categories: xKeys,
						crosshair: true
					},
					yAxis: {
						min: 0,
						title: {
							text: this.title
						}
					},
					plotOptions: {
						series: {
							stacking: 'normal'
						}
					},
					series: series
				};
      },

      barChartOptions() {
        let categories = this.insight.value.map(bin => bin[0]);
         let chart = (this.isString || typeof categories[0] === 'string') ? 'bar' : 'column';
        if (this.chartType === "column") {
          chart = this.chartType
        }

        this.chartType = (!!this.chartType) ? this.chartType : chart;
        let context = this
				return {
				  // let test = this;
					chart: {
						type: this.chartType
					},
					title: {
						text: titleCase(this.insight.title)
					},
					xAxis: {
						categories: categories,
						crosshair: true,
            title: {
							text: `${this.insight.config.xlabel}`
						}
					},
					yAxis: {
						min: 0,
						title: {
							text: `${this.insight.config.ylabel}`
						}
					},
					tooltip: {
						headerFormat: '',
						pointFormat: '<b>{point.y}</b>',
						footerFormat: '',
						shared: true,
						useHTML: true
					},
					plotOptions: {
						column: {
							pointPadding: 0.2,
							borderWidth: 0,
              dataLabels: {
                enabled: true,
                // format: '<b>{point.y}</b>'
                formatter: function() {
                  return context.abbreviateNumber(this.y)
                }
              }
						},
            bar: {
							pointPadding: 0.2,
							borderWidth: 0,
              dataLabels: {
                enabled: true,
                formatter: function() {
                  return context.abbreviateNumber(this.y)
                }
              }
						}
					},
					series: [{
						showInLegend: false,
						name: titleCase(this.insight.title),
						data: this.insight.value.map(point => point[1])
					}]
				};
      },

      groupedBarChartOptions() {
        let categories = this.insight.value.categories;
        console.log("values group", this.insight.value)
         let chart = (this.isString || typeof categories[0] === 'string') ? 'bar' : 'column';
        let d = this.insight.value.data
        let yaxis = [{"min": 0, "title": {"text": d[0].name}}]
        d[0]["yAxis"] = 0
        for (let i=1; i<d.length; i++) {
          yaxis.push({"min": 0, "title": {"text": d[i].name}, "opposite": true})
          d[i]["yAxis"] = i
        }
        if (this.chartType === "column") {
          chart = this.chartType
        }
        let context = this
        this.chartType = (!!this.chartType) ? this.chartType : chart;
				return {
					chart: {
						type: this.chartType
					},
					title: {
						text: titleCase(this.insight.title)
					},
					xAxis: {
						categories: categories,
						crosshair: true,
            title: {
							text: `${this.insight.config.xlabel}`
						}
					},
					yAxis: yaxis,
					tooltip: {
						headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
					},
					plotOptions: {
						column: {
							pointPadding: 0.2,
							borderWidth: 0,
              dataLabels: {
                enabled: true,
                formatter: function() {
                  return context.abbreviateNumber(this.y)
                }
              }
						},
            bar: {
							pointPadding: 0.2,
							borderWidth: 0,
              dataLabels: {
                enabled: true,
                formatter: function() {
                  return context.abbreviateNumber(this.y)
                }
              }
						}
					},
					series: this.insight.value.data
				};
      },

      pieChartOptions() {
        this.chartType = (!!this.chartType) ? this.chartType : 'pie';
        let context = this
				return {
					chart: {
						type: this.chartType,
					},
					title: {
						text: titleCase(this.insight.title)
					},
					tooltip: {
						pointFormat: '<p>Count: <b>{point.y}</b><br/>Percentage: <b>{point.percentage:.1f}%</b></p>'
					},
					plotOptions: {
						pie: {
							showInLegend: true,
							allowPointSelect: true,
							cursor: 'pointer',
							dataLabels: {
								enabled: true,
                formatter: function() {
                  return context.abbreviateNumber(this.y)
                }
							}
						}
					},
					legend: {
						itemDistance: 5,
						itemStyle: {
							fontSize: '11px'
						}
					},
					series: [{
						name: titleCase(this.insight.title),
						colorByPoint: true,
						data: this.insight.value.map(point => ({
							name: maybeMissingValueLabel(point[0]),
							y: point[1]
						}))
					}]
				};
      },

      drillDownChartOptions() {
        let series = this.insight.value;
        series = this.generateData(series)
        let seriesData = series[0];
        let drillDownData = series[1]
        let newSeries = seriesData;
        let chart = "column"
        this.chartType = (!!this.chartType) ? this.chartType : chart;
        return {
          chart: {
            type: this.chartType
          },
          title: {
            text: titleCase(this.insight.title)
          },
          subtitle: {
            text: `${this.insight.config.subtitle}`
          },
          accessibility: {
            announceNewData: {
              enabled: true
            }
          },
          xAxis: {
            type: 'category',
            title: {
              text: `${this.insight.config.xlabel}`
            }
          },
          yAxis: {
            title: {
              text: `${this.insight.config.ylabel}`
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.label}'
              }
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
          },
          series: [newSeries],
          drilldown: {
            series: drillDownData
          }
        };
      },

      mapChartOptions() {
        return {
          chart: {
            map: "myMapName",
            type: "map"
          },
          title: {
            text: this.insight.title
          },
          legend: {
            enabled: false
          //   layout: 'horizontal',
          //   borderWidth: 0,
          //   backgroundColor: 'rgba(255,255,255,0.85)',
          //   floating: true,
          //   verticalAlign: 'bottom',
          //   // y: 5
          },
          mapNavigation: {
            enabled: true
          },

          colorAxis: {
            min: 1,
            type: 'logarithmic',
            minColor: '#EEEEFF',
            maxColor: '#000022',
            stops: [
              [0, '#EFEFFF'],
              [0.67, '#4444FF'],
              [1, '#000022']
            ]
          },
          yAxis: {
            gridLineWidth: 0,
             minorGridLineWidth: 0,
            minorTickWidth: 0,
            labels: {
              enabled: false
            },
             title: {
              text: ""
            }
          },
          xAxis: {
            gridLineWidth: 0,
             minorGridLineWidth: 0,
            minorTickWidth: 0,
            minorTickLength: 0,
            labels: {
              enabled: false
            }
          },
          series: [
            {
              name: this.insight.title,
              states: {
              },
              dataLabels: {
                enabled: true,
                color: '#FFFFFF',
                format: "{point.name}"
              },
              data: this.insight.value
            }
          ]
        }

      }
    },

    watch: {
      // dashboard_: function(val) {
      //   if (!!val) {
      //     this.dashboardId = this.dashboard_;
      //   }
      // },

      range_value(val) {
        const {start, end} = val;
        if (start != null && end != null) {
          this.start_date = start;
          this.end_date = end;
          this.reloadData();

        } else {
          console.log("something is not complete")
        }
      }
    },

    methods: {
      selectReport() {
        console.log("Checker: ", this.report_);
        this.insight = this.reportData[this.report_];
      },

      getReport() {
        var dashboard = this.getDashboard();
        const request_data = "?dashboard_id=" + this.dashboardId;
        console.log("Request Dashboard: ", this.dashboardId, this.dashboard_);
        if (!!this.dashboard_ && !!this.dashboard_.report_ids) {
          axios.get(
            fullURL(`/dashboards/report/${this.reportId}` + request_data)
          ).then(({data}) =>{
            console.log("Response Data: ", {'text': data.title, 'value': data.id});
            this.insight = this.processChartData(data, data.id);
            // reports.push({'text': data.title, 'value': data.id});
          })
        }
      },

      getDashboard() {
        if (!!this.dashboardId) {
          this.$store.state.files.dashboards.forEach(dashboard => {
            if (dashboard.id === this.dashboardId) {
              this.dashboard_ = dashboard;
              return dashboard;
            }
          });
        } else {

        }
        return null;
      },

      redrawChart() {
        console.log("Selected field: ", this.selectedItem);
        this.insight.title += " - " + this.selectedItem;
        this.chartData = this.insight.value[this.selectedItem];
        return this.chartOptions;
      },

      switchChart() {
        console.log('switch', event.target.text);
        this.chartType = event.target.text;
        if (this.chartType === 'line') this.chartType = 'spline';
        if (this.chartType === 'area') this.chartType = 'areaspline';
        if (this.chartType === 'pie') console.log("Data: ", this.chartData);
        return this.chartOptions;
      },

      isActive(f) {
        const index = () => {
          if (key === "customers") return 0;
          if (key === "transactions") return 1;
          if (this.fileExists("transactions")) return 2;
          return 1;
        };

        return this.idList.indexOf(f) === this.tab;
      },

      formatDateText(month_year) {
        let month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        let month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        if (month_year && month_year.includes("-")) {
          let res = month_year.split("-");
          return month_names[res[1] - 1] + " " + res[2] + " " + res[0];
        }
        else if (month_year && month_year.includes("/")) {
          let res = month_year.split("/");
          return month_names_short[res[0] - 1] + " " + res[1];
        }
        return month_year;
      },

      abbreviateNumber(number, precision) {
        var SI_SYMBOL = ["", "k", "M", "B", "T", "P", "E"];
        var tier = Math.log10(number) / 3 | 0;
        if(tier == 0) {
          if (number % 1 !== 0) {
            return round(number, precision)
          }
          return number;
        }
        var suffix = SI_SYMBOL[tier];
        var scale = Math.pow(10, tier * 3);
        var scaled = number / scale;
        return scaled.toFixed(1) + suffix;
      },

      processChartData(data, id) {
        let report_id = id;
        let position = 0;
        let group_name = null;

        if (group_name) {
          if (this.groupView === null) {
            this.groupView = group_name
          }
          if (group_name in this.groups) {
            this.groups[group_name].push(report_id)
          } else {
            this.groups[group_name] = [report_id]
            this.groupNames.push({text: group_name.toUpperCase(), value: group_name})
          }
        }
        let enabled = true
        if (this.groupView !== null) {
          enabled = this.groupView === group_name
        }

        // if (data.report_type === 'summary') {
        //   this.summary_insights.push({"id": report_id, "position": position, "group_name": group_name, "sumdata": data, "enabled": enabled});
        //   this.summary_insights.sort(function (a, b) {
        //     return a.position - b.position;
        //   })
        // } else if (data.report_type === 'growth_chart') {
        //   this.growth_chart_config = data;
        //   let col = data['collection'];
        //   let filters = this.filter;
        //   this.growth_data = data.chart_data.data;
        // }
        if (data.report_type === 'chart') {
          if (data.chart_config.drill_down && data.chart_config.subtitle) {
            return {
              "id": report_id,
              "position": position,
              "title": data.title,
              "config": data.chart_config,
              "value": data.chart_data.data,
              "group_name": group_name,
              "enabled": enabled
            };
          } 
          else if (data.chart_config.grouped) {
            for (let d = 0; d < data.chart_data.data.categories.length; d++) {
              data.chart_data.data.categories[d] = this.formatDateText(data.chart_data.data.categories[d])
            }
            return {
              "id": report_id,
              "position": position,
              "title": data.title,
              "config": data.chart_config,
              "value": data.chart_data.data,
              "group_name": group_name,
              "enabled": enabled
            };
          } 
          else {
            if (data.chart_config.xlabeltype && data.chart_config.xlabeltype.toLowerCase() === "date") {
              data.chart_data.data.sort(this.sortByMonthYearDate)
            }
            return {
              "id": report_id,
              "position": position,
              "title": data.title,
              "config": data.chart_config,
              "value": data.chart_data.data,
              "group_name": group_name,
              "enabled": enabled
            };
          }
        }
      },

      reloadData() {
        let date_range = this.range_value;

        let start_date = null;
        let end_date = null;

        if (date_range != null) {
          start_date = date_range.start
          end_date = date_range.end
        }

        let request_data = "?dashboard_id=" + this.dashboardId;
        if (start_date != null && end_date != null) {
          request_data += "&start_date=" + start_date + "&end_date=" + end_date;
        }

        axios.get(
          fullURL(`/dashboards/report/${this.reportId}` + request_data)
        ).then(({data}) =>{
          console.log("Response Data: ", {'text': data.title, 'value': data.id});
          this.insight = this.processChartData(data, data.id);
          // reports.push({'text': data.title, 'value': data.id});
        })
      }
    },
  };
</script>

<style scoped>

</style>
